module.exports = __webpack_public_path__ + "img/2.98cb67d2.png";